import closeBtn from 'Assets/images/close-btn.svg';
import emptyChatSrc from 'Assets/images/empy-states/empty-conversations-list.png?inline';
import { MobXProviderContext, observer } from 'mobx-react';
import { useUIStore } from 'Modules/ui/index.store';
import { HistoryChatBubble } from 'Modules/videoHistory/components/HistoryChatBubble';
import moment from 'moment-timezone';
import React from 'react';
import { RootStoreProps } from 'Stores/RootStore.types';
import { EmptyState } from '~/lib/ui/emptyState';
import {
  SidebarContent,
  SidebarHeader,
  SidebarSeparator,
} from '~/lib/ui/sidebar';
import { cn } from '~/lib/utils';
import { ChatHistoryProps } from './index.types';

export const ChatHistory: React.FC<ChatHistoryProps> = observer(
  ({ hidden }) => {
    const { conversation: conversationStore } =
      React.useContext<RootStoreProps>(MobXProviderContext);

    const { setIsChatHistoryOpen } = useUIStore();

    const chatMessages =
      conversationStore.videoHistoryDetails?.data?.chatMessages;
    const hasMessages = (chatMessages?.length ?? 0) > 0;

    return (
      <div
        className={cn('history-video-chat flex flex-col h-full', {
          '!hidden': hidden,
        })}
      >
        <SidebarHeader className="justify-center h-[78px]">
          <div className="flex justify-between items-center pl-8 pr-3.5">
            <h4 className="text-m">Chat</h4>
            <img
              src={closeBtn}
              className="pointer w-4 h-4"
              onClick={() => setIsChatHistoryOpen(false)}
            />
          </div>
        </SidebarHeader>

        <SidebarSeparator />

        <SidebarContent className="overflow-y-auto px-6 pt-4">
          {hasMessages ? (
            chatMessages.map((message) => {
              const personId = message.personId.toString();
              const time = moment(message.createTime).format('hh:mm A');

              return (
                <HistoryChatBubble
                  key={message.messageText + message.createTime}
                  text={message.messageText}
                  personId={personId}
                  displayName={message.displayName}
                  timestamp={time}
                  testId="chat-history-bubble"
                />
              );
            })
          ) : (
            <EmptyState
              illustration={
                <img
                  src={emptyChatSrc}
                  alt=""
                  aria-hidden
                  width={173.15}
                  className="-my-8"
                />
              }
              title="Meeting chat is empty"
              description={`When participants send messages during\n the meeting, they'll appear here.`}
              className="h-[90%] min-h-fit"
              descriptionClassName="whitespace-pre-line"
              testID="chat-history"
            />
          )}
        </SidebarContent>
      </div>
    );
  }
);
